// eslint-disable-next-line import/no-cycle
import HTTP from '../http/common';

export default {

  /**
   * @returns @description lobbies list
   */
  list() {
    return HTTP.get('lobby/active');
  },

  /**
   * @returns @description init add form lobby
   */
  initAdd() {
    return HTTP.get('lobby/initAdd');
  },

  /**
   * @returns @description Create new lobby
   */
  add(data) {
    return HTTP.post('lobby/add', data);
  },

  /**
   * @returns @description GEt details lobby by id
   */
  get(id) {
    return HTTP.get(`lobby/details/${id}`);
  },

  /**
   * @returns @description Get coach list by login
   */
  getCoach(text) {
    return HTTP.get(`lobby/getCoachByWarzoneName/${text}`);
  },
};
